import React, { useState, useEffect } from "react";

// import CategoryCard from "./CategoryCard";
import CopyCategory from "./CopyCategory";
import CreateCategory from "categories/List/CreateCategory";
import RowCard from "./RowCard";

import SearchBar from "./SearchBar";

import OrganizationSelect from "organizations/OrganizationSelect";

import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  UPDATE_SURVEY_STRUCTURE_PAGE_NUMBER,
  SG_GET_SURVEY_STRUCTURES,
} from "constants/actions";

// shadcn/ui
import { Alert, AlertDescription } from "components/ui/alert";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "components/ui/card";
import { Button } from "components/ui/button";
import { Separator } from "components/ui/separator";
import { Skeleton } from "components/ui/skeleton";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "components/ui/pagination";
import { TriangleAlert } from "lucide-react";

const Categories = ({ setOrgName }) => {
  const dispatch = useDispatch();

  const [organizationId, setOrganizationId] = useState(false)

  const [searchTerm, setSearchTerm] = useState("");

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(1)
  const [resetPageLoad, setResetPageLoad] = useState(false)

  const { 
    get_survey_structure,
    get_survey_structure_copied,
    get_selectedOrg } = useSelector(
      (state) => ({
        get_survey_structure: state.surveystructure,
        get_survey_structure_copied: state.surveystructure.survey_structure_copied,
        get_selectedOrg: state.selectedOrg,
      }),
      shallowEqual
    );

  useEffect(() => {
    if (organizationId) {
      dispatch({
        type: SG_GET_SURVEY_STRUCTURES,
        payload: `organization=${organizationId}`,
      });
    }
    else if (searchTerm) {
      dispatch({
        type: SG_GET_SURVEY_STRUCTURES,
        payload: `page=${page}&search=${searchTerm}`,
      });
    }
    
  }, [dispatch, organizationId, resetPageLoad, searchTerm, page]);

  useEffect(() => {
    setOrgName(false)
  }, [setOrgName]);

  useEffect(() => {
    setOrganizationId(get_selectedOrg?.organization?.id)
  }, [get_selectedOrg]);

  useEffect(() => {
    setLoading(true)
    setResults([])
    // setPage(1)
    setTotalPages(1)
    setPage(get_survey_structure?.pageNumber)
    if (get_survey_structure?.survey_structure?.results) {
      setResults(get_survey_structure?.survey_structure?.results);
      if (get_survey_structure?.count) {
        setTotalPages(Math.ceil(get_survey_structure?.count / get_survey_structure?.page_size))
        if (get_survey_structure?.count % get_survey_structure?.page_size) {
          setTotalPages(Math.ceil(get_survey_structure?.count / get_survey_structure?.page_size))
        }
      }
    }

  }, [get_survey_structure, resetPageLoad, organizationId]);

  useEffect(() => {
    if (get_survey_structure_copied?.new_survey_structure_id > 0) {
      dispatch({
        type: SG_GET_SURVEY_STRUCTURES,
      });
    }
  }, [get_survey_structure_copied, dispatch]);


  function handlePageChange(event, value) {
    // setPage(value.activePage);
    dispatch({
      type: UPDATE_SURVEY_STRUCTURE_PAGE_NUMBER,
      payload: value.activePage,
    });
  }

  useEffect(() => {
    if (loading) {
      const timer1 = setTimeout(() => {
        setLoading(false)
      }, 2000)
      return () => clearTimeout(timer1)
    }
  }, [loading]);

  const goToPage = (nextPage) => {
    if (!nextPage || nextPage === page) return;
    handlePageChange(null, { activePage: nextPage });
  };

  const renderPaginationItems = () => {
    const items = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i += 1) {
        items.push({ page: i, active: i === page });
      }
      return items.map((item) => (
        <PaginationItem key={`page-${item.page}`}>
          <PaginationLink href="#" isActive={item.active} onClick={(e) => { e.preventDefault(); goToPage(item.page); }}>
            {item.page}
          </PaginationLink>
        </PaginationItem>
      ));
    }
    // Large page counts with ellipses
    const pages = new Set([1, 2, page - 1, page, page + 1, totalPages - 1, totalPages]);
    const sorted = Array.from(pages).filter(p => p >= 1 && p <= totalPages).sort((a, b) => a - b);
    let prev = 0;
    return sorted.flatMap((p, idx) => {
      const parts = [];
      if (p - prev > 1 && idx !== 0) {
        parts.push(
          <PaginationItem key={`ellipsis-${p}`}>
            <span className="px-2">…</span>
          </PaginationItem>
        );
      }
      parts.push(
        <PaginationItem key={`page-${p}`}>
          <PaginationLink href="#" isActive={p === page} onClick={(e) => { e.preventDefault(); goToPage(p); }}>
            {p}
          </PaginationLink>
        </PaginationItem>
      );
      prev = p;
      return parts;
    });
  };

  return (
    <div className="mb-8 space-y-6">
      <Alert className="border-orange-500/40 bg-orange-50 dark:bg-orange-950/20">
        <TriangleAlert className="h-4 w-4" />
        <AlertDescription>
          This data is crucial for the entire survey. Please do not change or add anything on this page without consulting the support team. Any errors would appear below this message. Even if there are no errors, things may break if you change this file without proper knowledge. To modify please contact support.
        </AlertDescription>
      </Alert>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Copy Another Category</CardTitle>
            <CardDescription>Once copied you can use JSON data to change things</CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center">
            <CopyCategory
              organizationId={organizationId}
              setOrganizationId={setOrganizationId}
              trigger={<Button>+ Copy Another Category</Button>}
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Create New Category</CardTitle>
            <CardDescription>Once created you can use JSON data to update</CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center">
            <CreateCategory
              organizationId={organizationId}
              setOrganizationId={setOrganizationId}
              trigger={<Button>+ Create New Category</Button>}
            />
          </CardContent>
        </Card>
      </div>

      <Separator />

      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />

      <OrganizationSelect setResetPageLoad={setResetPageLoad} />

      {organizationId || searchTerm ? (
        <>
          {loading ? (
            <div className="space-y-3">
              <Skeleton className="h-24 w-full" />
              <Skeleton className="h-24 w-full" />
              <Skeleton className="h-24 w-full" />
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {results && results.length > 0 ? (
                results.map((result) => (
                  <RowCard row={result} key={result?.id} />
                ))
              ) : (
                <Alert variant="destructive">
                  <TriangleAlert className="h-4 w-4" />
                  <AlertDescription>No Survey Structure found for this organization.</AlertDescription>
                </Alert>
              )}
            </div>
          )}

          <div className="px-4 py-6">
            <Pagination>
              <PaginationContent>
                <PaginationItem>
                  <PaginationPrevious href="#" onClick={(e) => { e.preventDefault(); goToPage(page > 1 ? page - 1 : 1); }} />
                </PaginationItem>
                {renderPaginationItems()}
                <PaginationItem>
                  <PaginationNext href="#" onClick={(e) => { e.preventDefault(); goToPage(page < totalPages ? page + 1 : totalPages); }} />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </div>
        </>
      ) : (
        <Alert className="border-orange-500/40 bg-orange-50 dark:bg-orange-950/20">
          <TriangleAlert className="h-4 w-4" />
          <AlertDescription>Please select an organization to view the list of files.</AlertDescription>
        </Alert>
      )}

    </div>
  );
};

export default Categories;